import React, { useEffect, useMemo, useState, useRef } from 'react'
import styles from './index.less'

function Dispute(props) {

  return (
    <div id="dispute">
      <div className={styles['dispute-main']}>
        <h1>纠纷处理措施</h1>
        <p>武汉风行在线技术有限公司营运的各项服务在此特别提醒用户在注册、登陆本平台前请务必仔细阅读本《纠纷处理》（未成年人应当在其法定监护人陪同下阅读）中的各个条款，以确保您在享受平台服务的同时维护自身合法权益</p>
        <h3>一、用户之间纠纷处理方式</h3>
        <p>1．武汉风行在线技术有限公司仅作为运营商，如若本平台用户之间发生纠纷且无法协商一致的，可向国家相关行政机关或司法机关寻求解决包括但不限于向公安机关报案、申请仲裁或向人民法院提起诉讼等。</p>
        <p>武汉风行在线技术有限公司将会为实名注册用户提供必要的协助和支持，并根据有关行政机关和司法机关的要求承担一定的举证责任或采取必要措施。</p>
        <p>2．本平台用户之间发生纠纷的，也可向武汉风行在线技术有限公司的客服人员投诉并举证。用户需提供与其账号注册信息一致的个人有效身份证件和其他武汉风行在线技术有限公司要求提供的相关证据。经武汉风行在线技术有限公司审核确认后，可以给予必要的协助和支持。</p>
        <h3>二、用户与武汉风行在线技术有限公司之间纠纷处理方式</h3>
        <p>1．如本平台用户对武汉风行在线技术有限公司的服务有任何异议的，可以向武汉风行在线技术有限公司的客服人员投诉并举证。查证属实的，xx公司将立即更正并按照现行法律规定给予用户必要的补偿。</p>
        <p>2．如本平台用户对武汉风行在线技术有限公司的服务有任何异议的，也可以向双方约定（具体参见《服务协议》）武汉风行在线技术有限公司的公司所在地人民法院提起诉讼。</p>
      </div>
    </div>
  )
}

export default Dispute
